import { FirstPage, ChevronLeft, ChevronRight, LastPage } from '@mui/icons-material';

import React from 'react';

import { makeStyles } from "@mui/styles";

import { IconButton } from '@mui/material';


const useStyles = makeStyles(() => ({
    tablePagination: {
        display: 'flex',
        fontSize: '0.7rem',
        
        "& .MuiButtonBase-root" :{
            padding : '0px',
        },
        "& .MuiSvgIcon-root": {
            width: '0.7em',
            height: '0.7em'
        },
        "& .pagination": {
            flex: 1,
            justifyContent: 'flex-end'
        }
    }
}));

const Pagination = (props) => {
    const { currentPage, pageCount, totalResults, pageChange } = props;
    const classes = useStyles();
    const totalPages = props.totalPages > 0 ? props.totalPages : (totalResults > 0 ? Math.ceil(totalResults / pageCount): 1)
    const handlePagination = (page) => {
        pageChange(page)
    }
    return (<nav>
        <div className={classes.tablePagination}>
            <div className="pagination" data-testid="record-count">
                [{((currentPage - 1) * pageCount) + (totalResults > 0 ? 1: 0)}] to [{(currentPage * pageCount) < totalResults ? (currentPage * pageCount) : totalResults}] of [{totalResults}]
            </div>
            <ul className="pagination">
                <li className="page-item mr-2">
                    <IconButton onClick={() => handlePagination(1)} disabled={currentPage === 1} data-testid="FirstPageIcon">
                        <FirstPage />
                    </IconButton>
                </li>
                <li className="page-item mr-2">
                    <IconButton onClick={() => handlePagination(currentPage - 1)} disabled={currentPage === 1} data-testid="ChevronLeftIcon">
                        <ChevronLeft />
                    </IconButton>
                </li>
                <li className="page-item" data-testid="page-count">
                    {`Page [${currentPage}] of [${totalPages}]`}
                </li>
                <li className="page-item ml-2">
                    <IconButton onClick={() => handlePagination(currentPage + 1)} disabled={currentPage === totalPages} data-testid="ChevronRightIcon">
                        <ChevronRight />
                    </IconButton>
                </li>
                <li className="page-item ml-2 mr-4">
                    <IconButton onClick={() => handlePagination(totalPages)} disabled={currentPage === totalPages} data-testid="LastPageIcon">
                        <LastPage />
                    </IconButton>
                </li>
            </ul>
        </div>
    </nav>)
}
export default Pagination;